module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Regular.c3bc8fce.ttf";